import { render, staticRenderFns } from "./text-ellipsis.vue?vue&type=template&id=e52e9526&scoped=true";
import script from "./text-ellipsis.vue?vue&type=script&lang=js";
export * from "./text-ellipsis.vue?vue&type=script&lang=js";
import style0 from "./text-ellipsis.vue?vue&type=style&index=0&id=e52e9526&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "e52e9526", null);
export default component.exports;